import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage/HomePage";
import Register from "./components/Users/Register/Register";
import Login from "./components/Users/Login/Login";
import Navbar from "./components/Navigation/Navbar";
import UpdateCategory from "./components/Categories/UpdateCategory";
import UpdatePost from "./components/Posts/UpdatePost";
import CreatePost from "./components/Posts/CreatePost";
import UpdateComment from "./components/Comments/UpdateComment";
import AddNewCategory from "./components/Categories/AddNewCategory";
import PostsList from "./components/Posts/PostsList";
import PostDetails from "./components/Posts/PostDetails";
import CategoryList from "./components/Categories/CategoryList";
function App() {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="/register" element={<Register/>} />  
        <Route path="/login" element={<Login/>} />  
        <Route path="/update-category/:id" element={<UpdateCategory/>}/>
        <Route path="/update-post/:id" element={<UpdatePost/>}/>
        <Route path="/create-post" element={<CreatePost/>} />
        <Route path="/update-comment/:id" element={<UpdateComment/>}/>
        <Route path="/add-category" element={<AddNewCategory/>} />
        <Route path="/posts" element={<PostsList/>} />
        <Route path="/posts/:id" element={<PostDetails/>} />
        <Route path="/category-list" element={<CategoryList/>} />
      </Routes>
    </Router>
  );
}

export default App;
